declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ActorEducationInfoRequest, ActorEducationInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppData } from '../../../../models/appdata';
import { DBOperation } from '../../../../enums/enum';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NgbEducationInfoModal } from './modals/educationinfo.modal';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';






@Component({
  selector: 'educationinfo',
  templateUrl: './educationinfo.component.html',
  styleUrls: ['./educationinfo.component.scss']
})

export class EducationInfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  public isRequesting: boolean = false;

  CurrentActorEducationInfoRequest: ActorEducationInfoRequest;
  CurrentActorEducationInfoController: ActorEducationInfoController[];

  public ApiResData: ApiResponseModel;
  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal) { }

  ngOnInit() {

    this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEducationInfoController = new Array<ActorEducationInfoController>();
    this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorEducationInfoController();
    }

  }

  GetActorEducationInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorEducationInfoController(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorEducationInfoController = this.ApiResData.Result;
          this.initGridButton();

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }





  isREADONLY: boolean = false;
  exportFileName: string = "ActorEducationInfoList_";
  dbops: DBOperation;
  columns: any[] = [
    {
      display: 'Course Study',
      variable: 'CourseStudy',
      filter: 'text',
    },
    {
      display: 'Institute Name',
      variable: 'InstituteName',
      filter: 'text'
    }
    ,
    {
      display: 'From',
      variable: 'StartFrom',
      filter: 'date'
    }
    ,
    {
      display: 'To',
      variable: 'CompletedAt',
      filter: 'date'
    }

  ];
  sorting: any = {
    column: 'StartFrom',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];
    this.gridbtns = [

      {
        title: 'X',
        keys: ["EducationCode"],
        action: DBOperation.delete,
        ishide: false
      },
      {
        title: 'Detail',
        keys: ["EducationCode"],
        action: DBOperation.detail,
        ishide: false
      },
      {
        title: 'Doc',
        keys: ["ActorDocCode"],
        action: DBOperation.doc,
        ishide: false
      },

    ];

  }

  gridaction(gridaction: any): void {

    switch (gridaction.action) {
      case DBOperation.create:
        this.openNewContent();
        break;

      case DBOperation.delete:



        //  this.DeleteLegalInfoByCode(gridaction.values[0].value);

        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() => {



          this.DeleteLegalInfoByCode(gridaction.values[0].value);

        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        })

        break;
      case DBOperation.detail:
        this.OpenDetailContent(gridaction.values[0].value);
        break;
      case DBOperation.doc:
        this.openDocContent(gridaction.values[0].value);

        break;

    }
  }
  del_(EducationCode: any) {

    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteLegalInfoByCode(EducationCode);

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteLegalInfoByCode(EducationCode: any) {



    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 3;
    this.CurrentActorEducationInfoRequest.EducationCode = EducationCode;
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {



          // alertFunctions.AlertParam('Saved Successfully.....!');
          swal(
            'Deleted!',
            'Delete Operation Completed Successfully.',
            'success'
          )


          this.stopRefreshing();
          this.GetActorEducationInfoController();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  openNewContent() {
    const modalRef = this.modalService.open(NgbEducationInfoModal)
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetActorEducationInfoController() })

  }
  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal,options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }

  OpenDetailContent(EducationCode: any) {

    var CurrentActorEducationInfoControllerByCode = this.CurrentActorEducationInfoController.filter(x => x.EducationCode === parseInt(EducationCode));
    if (CurrentActorEducationInfoControllerByCode.length > 0) {
      const modalRef = this.modalService.open(NgbEducationInfoModal);
      modalRef.componentInstance.IsShowDetail = true;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      modalRef.componentInstance.CurrentActorEducationInfoControllerByCode = CurrentActorEducationInfoControllerByCode[0];


    }
    else {
      alertFunctions.AlertParam('No Data Exits....!S');
    }

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
